import { Injectable } from '@angular/core';



export  class InvalidField{
  constructor(msg:string,name: string, validator : string){
    this.msg = msg;
    this.name = name;
    this.validator = validator;
  }
  name : string;
  msg : string;
  validator : string;
}

@Injectable({
  providedIn: 'root'
})
export class ValidationService {
  invalidFields : InvalidField[] = [];
  constructor() { }

  getFieldValidationMessage(fieldName : string) : string{
    return this.invalidFields.find(e =>{return e.name == fieldName}).msg;
  }

  isFieldValid(fieldName : string) : boolean{
    return this.invalidFields.find(e =>{return e.name == fieldName}) == undefined;
  }

  AddField(field : InvalidField){
    if(this.invalidFields.find(e =>{return e.name == field.name}) == undefined){
      this.invalidFields.push(field);
    }
  }

  removeValidation(fieldName: string) {
    let invalidFieldcheck = this.invalidFields.find(e =>{return e.name == fieldName});
    if(this.invalidFields.indexOf(invalidFieldcheck) > -1){
      this.invalidFields.splice(this.invalidFields.indexOf(invalidFieldcheck),1);
    }
  }
}
